export enum LinkTypes {
  NONE = 'none',
  EXTERNAL = 'external',
  ROUTER = 'router',
  PROGRAMMATIC = 'programmatic',
}
